import { styled } from "@linaria/react"

export const SplitButtonContainer = styled.div`
  display: flex;
  align-items: center;

  & > :first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  & > :last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
  }
`
